// extracted by mini-css-extract-plugin
export default {"imageWrapper":"IS-z","hovered":"JS-z","hoverImage":"KS-z","mainImage":"LS-z","imageNoBackground":"MS-z","fullSizeImage":"NS-z"};